export enum DefinitionTitle {
  Tattoo = 'tattoo',
  Piercings = 'piercings',
  FacialHair = 'facial_hair',
  PhysicalAttributes = 'physical_attributes',
  TwinTriplet = 'twin_triplet',
}
